<template>
  <span
    v-tooltip="tooltip"
    class="sf-level-item-small live-input-action__container"
    :data-testid="`live-input-action-${icon}`"
    @click.prevent.stop="handleClick"
    @mouseenter.prevent.stop="handleMouseEnter"
    @mouseleave.prevent.stop="handleMouseLeave"
  >
    <a
      href="#"
      class="sf-btn sf-btn-small"
      tabIndex="-1"
      :class="iconContainerClass"
      @click.prevent.stop="handleClick"
    >
      <img v-if="iconPath" :src="$imagesRequire(iconPath)" />
      <div v-else :class="iconClass"></div>
    </a>
  </span>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconPath: {
      type: String,
      default: null,
    },
    iconContainerClasses: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'dark',
    },
    shouldPublishHoverEvents: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
  emits: ['click', 'mouseenter', 'mouseleave'],
  computed: {
    iconContainerClass() {
      return {
        [`sf-btn-${this.variant}`]: true,
        [this.iconContainerClasses]: true,
      }
    },
    iconClass() {
      return {
        [this.icon]: true,
      }
    },
  },
  methods: {
    handleClick() {
      this.$emit('click', this.icon)
    },
    handleMouseEnter() {
      if (this.shouldPublishHoverEvents) {
        this.$emit('mouseenter', this.icon)
      }
    },
    handleMouseLeave() {
      if (this.shouldPublishHoverEvents) {
        this.$emit('mouseleave', this.icon)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.live-input-action {
  &__container {
    margin: 0 8px 0 0;
  }
}
</style>
